import { DatePicker, DatePickerProps } from '@mui/x-date-pickers/DatePicker';
import { Dayjs } from 'dayjs';

import './DatePickerElement.scss';

interface DatePickerElementProps extends DatePickerProps<Dayjs, any> {

}

export default function DatePickerElement(props: DatePickerElementProps) {
    const combineClassName = `date-picker-element ${props?.className ?? ''}`

    return (
        <DatePicker format="DD/MM/YYYY" {...props} className={combineClassName} />
    )
}